import React from 'react';
import { useProgress } from '@react-three/drei';
import { useSpring, animated } from 'react-spring';

const Loader = () => {
  const { progress } = useProgress();
  const props = useSpring({
    to: { opacity: progress >= 100 ? 0 : 1 },
    from: { opacity: 1 }
  });

  const progressBarProps = useSpring({
    width: `${progress}%`,
    from: { width: '0%' }
  });

  const progressTextProps = useSpring({
    value: progress.toFixed(0),
    from: { value: '0' }
  });

  return (
    <animated.div
      style={{
        ...props,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.8)',
        color: 'white',
        zIndex: 1000,
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif', // Custom font family
      }}
    >
      <div style={{ width: '200px' }}> {/* Container for progress bar */}
        <h2 style={{ marginBottom: '20px' }}>Welcome to My Projects</h2> {/* Updated heading */}
        <p style={{ marginBottom: '20px' }}>Loading...</p> {/* Added loading text */}
        <div style={{ backgroundColor: '#555', height: '20px', borderRadius: '10px', overflow: 'hidden' }}> {/* Progress bar container */}
          <animated.div
            style={{
              ...progressBarProps,
              height: '100%',
              backgroundColor: '#4CAF50',
              borderRadius: '10px'
            }}
          ></animated.div> {/* Progress bar */}
        </div>
        <animated.p style={{ marginTop: '20px' }}>{progressTextProps.value.interpolate(value => `${value} %`)}</animated.p> {/* Display progress percentage */}
        <p style={{ fontSize: '14px' }}>Please wait while the projects are loading...</p> {/* Additional information */}
      </div>
    </animated.div>
  );
};

export default Loader;